import { controllerClassNameSuffix } from '@rappider/shared/definitions';

export const userDataModelName = 'User';
export const userControllerClassName = `${userDataModelName}${controllerClassNameSuffix}`;
